export default {
    callToAction: "Tells us more about you.",
    formId: "user_onboard_welcome",
    questions: [
        {
            question: "Which best describes you?",
            small: "If you're signing up on behalf of someone else, please let us know the nature of their account.",
            type: "single",
            answers: [
                {
                    answer: "HeartBeat (Love one who needs caregiving",
                    action: "continue",
                    key: "A"
                },
                {
                    answer: "Family member providing caregiving support",
                    action: "continue",
                    key: "B"
                },
                {
                    answer: "Just an Explorer",
                    action: "continue",
                    key: "C"
                },
                {
                    answer: "Medical Professional (Pro Account)",
                    action: "continue",
                    key: "D"
                },
                {
                    answer: "Independent Caregiver",
                    action: "continue",
                    key: "E"
                }
            ]
        },
        {
            question: "What device do you plan to primarily use D3rriana on?",
            small: "For the best experience, we recommend using a tablet, such as an iPad. It's worth noting that we are compatible with multiple platforms.",
            type: "single",
            answers: [
                {
                    answer: "Desktop or LapTop Computer",
                    action: "continue",
                    key: "A"
                },
                {
                    answer: "SmartPhone",
                    action: "continue",
                    key: "B"
                },
                {
                    answer: "Tablet",
                    action: "continue",
                    key: "C"
                }
            ]
        },
        {
            question: "We have a suite of interconnected applications known as MyApps. Could you share your goals with us to help us provide tailored recommendations?",
            type: "single",
            answers: [
                {
                    answer: "Cognition Games",
                    action: "continue",
                    key: "A"
                },
                {
                    answer: "Productivity/Organization",
                    action: "continue",
                    key: "B"
                },
                {
                    answer: "Health Monitoring",
                    action: "continue",
                    key: "C"
                },
                {
                    answer: "Family Engagement/Connection",
                    action: "continue",
                    key: "D"
                },
                {
                    answer: "Not Sure",
                    action: "continue",
                    key: "E"
                }
            ]
        },
        {
            question: "One last question: How many members are there in your caregiving family?",
            type: "single",
            answers: [
                {
                    answer: "1-3",
                    action: "continue",
                    key: "A"
                },
                {
                    answer: "4-7",
                    action: "continue",
                    key: "B"
                },
                {
                    answer: "8-10",
                    action: "continue",
                    key: "C"
                },
                {
                    answer: "10+",
                    action: "continue",
                    key: "D"
                },
                {
                    answer: "Corporate Account",
                    action: "continue",
                    key: "E"
                },
                {
                    answer: "Choose not to answer ",
                    action: "continue",
                    key: "F"
                }
            ]
        },

        {
            id: "thank-you",
            question: "We've developed a compact action plan to kickstart your caregiving journey.",
            type: "submit"
        }
    ],
    buttons:{
        launchBtnTxt: "All right",
        submitBtnTxt: "Let's Go"
    }
};
